import { Box, CircularProgress, Grid, IconButton } from "@mui/material";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import LabelValueDisplay from "../../UserScreen/InventoryPage/InventorySettings/components/LabelValue/LabelValueDisplay";
import AddEditInterfaceModal from "../../UserScreen/InventoryPage/InventorySettings/components/Modals/AddEditInterfaceModal";
import CommonModal from "../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal";
import SectionTitleWithHr from "../../UserScreen/InventoryPage/InventorySettings/components/SectionTitleWithHR/SectionTitleWithHr";
import InfoMessageBox from "../../UserScreen/InventoryPage/InventorySettings/components/InfoMsgBox/InfoMsgBox";
import { useState, useEffect } from "react";
import { convertDateTimeIntoTimezone, getDecodeURI } from "../../utils/util";
import ToggleWithLabel from "../../UserScreen/InventoryPage/InventorySettings/components/ToggleWithLabel/ToggleWithLabel";
import _ from "lodash";
import { syncDevice, updateDevice, createHighAvailability, highAvailability, getHighAvailabilityDevice, deleteHighAvailability } from "../../actions/Users/authenticateHighAvailability";
import { getEdgeEvents, getEdgeEventsFilter } from "../../actions/Users/authenticateEdgeEvents";
import { CREATE_HA, UPDATE_DEVICE, SYNC_DEVICE, DELETE_HIGH_AVAILABILITY } from "../../actions/types";
import deleteEnabled from "../../asset/image/deleteEnabled.svg";
import deleteDisabled from "../../asset/image/deleteDisabled.svg";
import ConfirmDialog from "../../components/ConfirmDialog";
import { CONFIRM_DIALOG_TITLE } from "../../config";
var Loader = require("react-loader");

export const EditHighAvailability = (props) => {
    const { open, setOpenHA, selectedOption, setSelectedOption, devicesIds, selectedVessel, updateDevice, updateDeviceData, updatingDevice, syncDevice, syncingDevice, highAvailability, creatingHighAvailability, syncDeviceData, products, errorObj, authReducer, location, createHighAvailability, createDeviceData, getHighAvailabilityDevice, highAvailabilityData, deleteHighAvailability, deleteHighAvailabilityData, deletingHighAvailability, gettingHaData } = props;
    const [isEnabled, setIsEnabled] = useState(true);
    const [selectedDevices, setSelectedDevices] = useState({
        primary_device: products?.[0]?.primary_device_name,
        secondary_device: products?.[0]?.secondary_device_name,
    });
    const [servingDevice, setServingDevice] = useState(products?.[0]?.serving_device_name);
    const [varient, setVarient] = useState('info');
    const [varientMsg, setVarientMsg] = useState<string>('High Availability enables syncing of configuration from Active to Standby device. Selecting a serving device is a manual process that takes about 10 minutes.');
    const [isSyncing, setIsSyncing] = useState(false);
    const [isPollingActive, setIsPollingActive] = useState(false);
    const deviceNameAndIdSeparator = " | ";

    const HA_ACTION_MESSAGES = {
        create: 'HA pair creation in progress...',
        update: 'HA pair update in progress...',
        sync: 'HA sync in progress...',
        delete: 'HA deletion in progress...',
    };
    const dispatch = useDispatch();
    const _q = getDecodeURI(location?.search);
    const handleToggle = (checked) => {
        setIsEnabled(checked);
        setSelectedOption(checked ? 'Primary' : '');
        setServingDevice(selectedDevices?.primary_device);
    }
    const [error, setError] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '', onConfirm: () => {} });

    const handleChange = (key: 'primary_device' | 'secondary_device', value: string) => {
        if (
            (key === 'primary_device' && value === selectedDevices.secondary_device) ||
            (key === 'secondary_device' && value === selectedDevices.primary_device)
        ) setError(true);
        else setError(false);
        const updated = {
            ...selectedDevices,
            [key]: value,
        };

        // If the selected radio (serving) matches the key, update serving_device too
        const selectedKey = selectedOption === 'Primary' ? 'primary_device' : 'secondary_device';

        setSelectedDevices(updated);
        if (key === selectedKey) {
            setServingDevice(value);
        }
        setVarient("info")
        setVarientMsg('High Availability enables syncing of configuration from Active to Standby device. Selecting a serving device is a manual process that takes about 10 minutes.')
    };

    const getPayload = (pDevice, sDevice, serving_device) => {
        pDevice = pDevice.includes(deviceNameAndIdSeparator) ? pDevice.split(deviceNameAndIdSeparator)[1] : pDevice;
        sDevice = sDevice.includes(deviceNameAndIdSeparator) ? sDevice.split(deviceNameAndIdSeparator)[1] : sDevice;
        serving_device = serving_device.includes(deviceNameAndIdSeparator) ? serving_device.split(deviceNameAndIdSeparator)[1] : serving_device;

        let payload = {
            primary_device: pDevice,
            secondary_device: sDevice,
            serving_device: serving_device
        }
        return payload;
    }

    const handleClose = () => {
        setOpenHA(false);
        setVarient("info")
        setVarientMsg('High Availability enables syncing of configuration from Active to Standby device. Selecting a serving device is a manual process that takes about 10 minutes.')
    }

    const triggerHAPolling = (actionType: string) => {
        const startedAt = Date.now();
        localStorage.setItem('ha_polling_state', JSON.stringify({ active: true, startedAt, actionType }));
        setIsPollingActive(true);
        setVarient('warning');
        setVarientMsg(HA_ACTION_MESSAGES[actionType] || 'HA action in progress...');
        window.dispatchEvent(new CustomEvent('ha_action_triggered', { detail: { startedAt, actionType } }));
    };

    const handleUpdate = () => {
        triggerHAPolling(errorObj ? 'create' : 'update');
        if (errorObj) {
            let payload = getPayload(selectedDevices.primary_device, selectedDevices.secondary_device, servingDevice);
            createHighAvailability(selectedVessel, payload, true)
        } else {
            let pDevice = selectedDevices?.primary_device;
            let sDevice = selectedDevices?.secondary_device;
            let serving_device = servingDevice;
            let payload = getPayload(pDevice, sDevice, serving_device);
            updateDevice(selectedVessel, payload, true)
        }
    }

    useEffect(() => {
        if (!_.isEmpty(updateDeviceData)) {
            const res = updateDeviceData;
            if (res.hasOwnProperty('data') && res.data.hasOwnProperty('success') && res.data.success == false) {
                setVarient('error');
                setVarientMsg(res.data.errors?.[0]?.message);
                setIsPollingActive(false);
                localStorage.removeItem('ha_polling_state');
            }
            dispatch({ type: UPDATE_DEVICE, payload: {} });
        }
        if (!_.isEmpty(createDeviceData)) {
            const res = createDeviceData;
            if(res?.data?.success == false){
                setVarient("error");
                setVarientMsg(res.data.errors?.[0]?.message);
                setIsPollingActive(false);
                localStorage.removeItem('ha_polling_state');
            }
            dispatch({ type: CREATE_HA, payload: {} });
        }
        if (!_.isEmpty(syncDeviceData)) {
            if(syncDeviceData.success !== true){
                setVarient("error");
                setVarientMsg("Sync Failed");
                setIsPollingActive(false);
                localStorage.removeItem('ha_polling_state');
            }
            dispatch({ type: SYNC_DEVICE, payload: {} });
        } 
        if(!_.isEmpty(deleteHighAvailabilityData)){
            if(deleteHighAvailabilityData?.success == true){
                setSelectedDevices({
                    primary_device: '',
                    secondary_device: ''
                });
                setSelectedOption('Primary');
            }
            else{
                setVarient("error");
                setVarientMsg("Delete Failed");
                setIsPollingActive(false);
                localStorage.removeItem('ha_polling_state');
            }
            dispatch({ type: DELETE_HIGH_AVAILABILITY, payload: {} });
        }
    }, [updateDeviceData, syncDeviceData, createDeviceData, deleteHighAvailabilityData])

    useEffect(() => {
        if(!_.isEmpty(highAvailabilityData)){
            if(highAvailabilityData?.success ==false){
                setVarient('info');
                setVarientMsg("Please Create a High Availability");
            }
        }
    },[highAvailabilityData])

    useEffect(() => {
        const newPrimary = products?.[0]?.primary_device_name;
        const newSecondary = products?.[0]?.secondary_device_name;
        if (newPrimary && newSecondary) {
            setSelectedDevices({
                primary_device: newPrimary,
                secondary_device: newSecondary,
            });
        }
    },[products])

    useEffect(() => {
        if (open) {
            highAvailability(selectedVessel);
            const stored = JSON.parse(localStorage.getItem('ha_polling_state') || '{}');
            if (stored?.active && stored?.startedAt) {
                const elapsed = Date.now() - stored.startedAt;
                if (elapsed < 30 * 30000) {
                    setIsPollingActive(true);
                    setVarient('warning');
                    setVarientMsg(HA_ACTION_MESSAGES[stored.actionType] || 'HA action in progress...');
                }
            }
        }
    }, [open, selectedVessel]);

    useEffect(() => {
        const handleLogUpdate = (e: any) => {
            const { description, isComplete, maxReached } = e.detail || {};
            if (isComplete || maxReached) {
                setIsPollingActive(false);
                selectedVessel && highAvailability(selectedVessel);
                if (maxReached) {
                    setVarient('info');
                    setVarientMsg('High Availability enables syncing of configuration from Active to Standby device. Selecting a serving device is a manual process that takes about 10 minutes.');
                } else {
                    setVarient('success');
                    setVarientMsg(description || 'Action completed successfully.');
                }
            } else if (description) {
                setVarient('warning');
                setVarientMsg(description);
            }
        };
        window.addEventListener('ha_log_update', handleLogUpdate);
        return () => window.removeEventListener('ha_log_update', handleLogUpdate);
    }, [selectedVessel]);


    const handleSync = () => {
        triggerHAPolling('sync');
        setIsSyncing(true);
        syncDevice(selectedVessel,{}, true);
        setTimeout(() => {
            setIsSyncing(false);
        }, 10000);
    }

    const handleDeleteHA = () => {
        setConfirmDialog({
            isOpen: true,
            title: CONFIRM_DIALOG_TITLE,
            subTitle: 'Are you sure you want to delete High Availability?',
            onConfirm: () => {
                triggerHAPolling('delete');
                deleteHighAvailability(selectedVessel, true);
            }
        });
    }

    const isSaveDisabled = !(
        selectedDevices.primary_device &&
        selectedDevices.secondary_device &&
        servingDevice &&
        selectedDevices.primary_device != selectedDevices.secondary_device
    );

    const originalServingDevice = products?.[0]?.serving_device_name ?? '';
    const hasChanged = errorObj ? true : servingDevice !== originalServingDevice;
    const isUpdateLoading = updatingDevice || creatingHighAvailability;

    const syncProps = {
        showSyncIcon: !errorObj,
        onSyncClick: handleSync,
        isSyncing: isSyncing || isPollingActive,
        setIsSyncing: setIsSyncing,
        disabled: isPollingActive
    }

    const element = (
        <div className="haPopup">
            <Box className="haDeleteButton">
                {!errorObj && (highAvailabilityData?.result?.last_successful_sync_at ?? highAvailabilityData?.last_successful_sync_at) && (
                    <div className="ha-last-sync-row">
                        <span className="ha-last-sync-label">Last Successful Sync: </span>
                        <span className="ha-last-sync-time">
                            {convertDateTimeIntoTimezone(highAvailabilityData?.result?.last_successful_sync_at ?? highAvailabilityData?.last_successful_sync_at, authReducer.userTimezone, "MM/DD/YYYY HH:mm")}
                        </span>
                    </div>
                )}
                {!errorObj && (
                    <IconButton sx={{ marginLeft: 'auto' }} onClick={handleDeleteHA} disabled={isPollingActive}>
                        <img src={isPollingActive ? deleteDisabled : deleteEnabled} />
                    </IconButton>
                )}
            </Box>
            <Grid>
                <Grid>
                    <SectionTitleWithHr
                        title={`Active ${selectedOption === 'Primary' ? "(Serving)" : ""}`}
                        showRadio={true}
                        isSelected={selectedOption === 'Primary'}
                        onRadioChange={() => {
                            setSelectedOption('Primary');
                            setServingDevice(selectedDevices.primary_device);
                        }}
                        disabled={!isEnabled}
                        showHoverMessage={true}
                        hoverMessage={selectedOption === 'Primary' ? 'Serving' : 'Non-Serving'}
                    />
                </Grid>
                <Grid className="HA-device">
                    <LabelValueDisplay
                        label=""
                        isDropdown
                        dropdownOptions={devicesIds}
                        value={selectedDevices.primary_device}
                        placeholder="Select Device"
                        onChange={(e) => handleChange('primary_device', e.target.value)}
                        disabled={!errorObj}
                    />
                </Grid>
            </Grid>
            <Grid >
                <Grid>
                    <SectionTitleWithHr
                        title={`Standby ${selectedOption === 'Secondary' ? "(Serving)" : ""}`}
                        showRadio={true}
                        isSelected={selectedOption === 'Secondary'}
                        onRadioChange={() => {
                            setSelectedOption('Secondary');
                            setServingDevice(selectedDevices.secondary_device);
                        }}
                        disabled={!isEnabled}
                        showHoverMessage={true}
                        hoverMessage={selectedOption === 'Secondary' ? 'Serving' : 'Non-Serving'}
                    />
                </Grid>
                <Grid className="HA-device">
                    <LabelValueDisplay
                        label=""
                        isDropdown
                        dropdownOptions={devicesIds}
                        value={selectedDevices.secondary_device}
                        placeholder="Select Device"
                        onChange={(e) => handleChange('secondary_device', e.target.value)}
                        disabled={!errorObj}
                        {...(error && { error: "Active and Standby cannot be the same device" })}
                    />
                </Grid>
            </Grid>
            {varient && (
                <InfoMessageBox
                    variant={varient}
                    message={
                        isPollingActive
                            ? <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <CircularProgress size={14} thickness={5} color="inherit" />
                                {varientMsg}
                              </span>
                            : <>{varientMsg}</>
                    }
                />
            )}
        </div>
    )

    return (
        <div>
            <CommonModal
                open={open}
                onClose={handleClose}
                onSave={handleUpdate}
                saveText={errorObj ? 'Create' : 'Update'}
                disableSave={isSaveDisabled || !hasChanged || isUpdateLoading || isPollingActive}
                title='High Availability'
                maxWidth='800px'
                syncProps={syncProps}
                showSyncStatus={false}
                children={element}
                showOnlineOffline={false}
                showLoader={gettingHaData || creatingHighAvailability || syncingDevice || updatingDevice || deletingHighAvailability}
            />
            <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
        </div>
    )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    selectedOu: state.authReducer.selectedOu,
    newSummaryStartDate: state?.authReducer?.newSummaryStartDate,
    newSummaryEndDate: state?.authReducer?.newSummaryEndDate,
    updateDeviceData: state.authReducer.updateDevice,
    updatingDevice: state.authReducer.updatingDevice,
    syncDeviceData: state.authReducer.syncDevice,
    syncingDevice: state.authReducer.syncingDevice,
    createDeviceData: state.authReducer.createHighAvailability,
    creatingHighAvailability: state.authReducer.creatingHighAvailability,
    highAvailabilityData: state.authReducer.highAvailability,
    deleteHighAvailabilityData: state.authReducer.deleteHighAvailability,
    deletingHighAvailability: state.authReducer.deletingHA,
    gettingHaData: state.authReducer.gettingHa
});
export default withRouter(
    connect(mapStateToProps, {
        updateDevice,
        syncDevice,
        createHighAvailability,
        highAvailability,
        getHighAvailabilityDevice,
        deleteHighAvailability
    })(EditHighAvailability)
);